<div class="client_pageBody space_book_page lg:max-w-[500px]">
  <div *ngIf="object">
    <!--Stepper-->
    <div class="flex justify-center mb-8">
      <div class="stepper">
        <div>
          <img src="/silone/silone_step.png" />
        </div>
        <div class="progressbar completed"></div>
        <div>
          <img src="/silone/silone_step.png" />
        </div>
        <div class="progressbar completed"></div>
        <div>
          <img src="/silone/silone_step.png" />
        </div>
      </div>
    </div>

    <div class="text-center mb-4">
      <div
        class="font-bold text-2xl"
        *ngIf="object.status==statusList.approved"
      >
        {{_common.BookingConfirmed}}
      </div>
      <div
        class="font-bold text-2xl"
        *ngIf="object.status!=statusList.approved"
      >
        {{_common.waitApproval}}
      </div>

      <!--For Space with Smart Lock-->
      <ng-container *ngIf="object.space.locked==true">
        <div *ngIf="object.status==statusList.approved" class="mt-2">
          <div>
            {{_common.QRCodeText1}}
            <span class="font-bold">{{_common.QRCodeText2}}</span>
          </div>
          <div>{{_common.or}}</div>
          <div *ngIf="object.passcode">
            {{_common.usePasscode}}:
            <div class="passcode_box">
              {{_common.passcode}}:
              <span class="font-bold">{{object.passcode}}</span>
              <fa-icon
                icon="copy"
                (click)="copyPasscode()"
                class="cursor-pointer ml-2"
              ></fa-icon>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="flex justify-center mt-4">
        <div class="mr-2">{{_common.bookingStatus.status}}:</div>
        <div class="app-chip Status" [ngClass]="object.status">
          {{ _common.bookingStatus[object.status] }}
        </div>
      </div>
    </div>
    <div
      *ngIf="(object.space.capacity > 1 || !object.space.capacity) && object.space.maxBookings<=1"
    >
      <div class="flex justify-between">
        <div class="flex items-end">
          {{_common.numParticipants}}: {{object.numParticipants}}
        </div>
        <img src="/silone/silone_friends_tgt.png" style="height: 40px" />
      </div>
      <button
        *ngIf="object.passcode && object.status==statusList.approved || object.status==statusList.pending"
        [matMenuTriggerFor]="invite_frd"
        class="app-btn btn-black w-full"
        style="font-size: larger; height: 49px"
      >
        {{_common.invite_frd}}
      </button>
    </div>

    <div class="card mt-2">
      <div class="cardBody">
        <div class="flex">
          <div class="spacer font-bold">
            {{formatLongDate(session.lang, object.startTime)}}
          </div>
          <div class="text-link link-blue" (click)="googleCalendar()">
            {{_common.AddToCalendar}}
          </div>
        </div>
        <div class="mb-2">
          {{formatDisplayTime(session.lang, object.startTime)}} -
          {{formatDisplayTime(session.lang,object.endTime)}}
          ({{formatMins(object.durationMins,_common)}})
        </div>
        <!-- <div *ngIf="inviteUrl">
          {{inviteUrl}}
        </div> -->
        <ng-container *ngIf="object.space; let o">
          <app-space-card
            [space]="$any(object.space)"
            class="space_card_noBorder"
          ></app-space-card>
        </ng-container>
      </div>
      <div class="cardDivider"></div>
      <div class="cardBody">
        <div class="font-bold text-lg mb-2">{{_common.CenterInfo}}</div>
        <div
          *ngIf="$any(object.space?.location); let location"
          class="item_info"
        >
          <div class="item_info">
            <div class="line_item">
              <fa-icon icon="phone-flip" class="icon"></fa-icon>
              {{location.tel}}
            </div>
            <div class="line_item">
              <fa-icon icon="map-location-dot" class="icon"></fa-icon>
              {{ lang(location.address,location.address_lang) }}
            </div>
            <div class="line_item">
              <fa-icon icon="clock" class="icon"></fa-icon>
              <div>
                <div *ngFor="let l of openingHours">
                  {{l}}
                  <!--{{ lang(l,l_lang) }}-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="object.contactName && object.contactName!=''" class="card">
      <div class="cardHeader">{{_common.ContactPerson}}</div>
      <div class="cardBody">
        <div class="flex">
          <div class="w-14">{{_common.name}}</div>
          <div>{{object.contactName}}</div>
        </div>
        <div class="flex">
          <div class="w-14">{{_common.email}}</div>
          <div>{{object.contactEmail}}</div>
        </div>
        <div class="flex">
          <div class="w-14">{{_common.tel_no}}</div>
          <div>{{object.contactMobile}}</div>
        </div>
      </div>
    </div>

    <!-- <div class="card">
      <div class="cardBody" style="font-size:19px;">
        <span class="font-bold">{{_common.numParticipants}}:</span>
        <ng-container *ngIf="object.space.capacity > 1 || !object.space.capacity">
          {{object.numParticipants}}
        </ng-container>
        <ng-container *ngIf="object.space.capacity == 1">
          {{_common.na}}
        </ng-container>

      </div>
    </div> -->
    <div class="card">
      <div class="cardHeader">{{_common.Remarks}}</div>
      <div class="cardBody space-y-4">
        <ng-container *ngIf="!object.remarks"> N/A </ng-container>
        {{object.remarks}}
      </div>
    </div>
    <div class="card">
      <div class="cardHeader">{{_common.SpaceFacilities}}</div>
      <div class="cardBody space-y-4">
        <div>
          <div class="underline">{{_common.FacilitiesIncluded}}</div>
          <ng-container *ngIf="!object.space.includedFacilities">
            N/A
          </ng-container>
          <div>
            {{
            lang($any(object.space)?.includedFacilities,$any(object.space)?.includedFacilities_lang)
            }}
          </div>
        </div>
        <div>
          <div class="underline">{{_common.AdditionalFacilities}}</div>
          <ng-container *ngIf="!object.facilities"> N/A </ng-container>
          <div *ngFor="let f of object.facilities" class="flex flex-wrap">
            {{ lang(f.name,f.name_lang) }}
            <!-- <span class="client_chip ml-1" [ngClass]="f.fee">
              {{ _common.Facility[f.fee] }}
              <span *ngIf="f.fee==fees.custom">$&nbsp;{{f.feeText}}</span>
            </span> -->
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-center mt-8">
      <div class="flex flex-col gap-4 items-center" style="width: fit-content">
        <!-- <div [matMenuTriggerFor]="invite_frd" class="client_button" style="width: 100%;">
          {{_common.invite_frd}}
        </div> -->

        <div (click)="bookAgain()" class="client_button btn_outline">
          {{_common.RebookSameSpace}}
        </div>
      </div>
    </div>

    <mat-menu #invite_frd="matMenu" class="user-dropDown">
      <div (click)="sharing.copy(object)">
        <fa-icon
          icon="copy"
          style="margin-right: 5px; color: #707070"
        ></fa-icon>
        {{_common.copy_invite_msg}}
      </div>
      <!-- <div (click)="sharing.share(object)">
        <fa-icon [icon]="['fab', 'whatsapp']"></fa-icon>
        {{_common.share_whatsapp}}
      </div> -->
      <div (click)="smartShare(object)">
        <fa-icon [icon]="['fab', 'whatsapp']"></fa-icon>
        {{_common.share_whatsapp}}
      </div>
    </mat-menu>
  </div>
</div>
